// src/components/Booking/DaySlots.js
import React, { useState, useEffect } from 'react';
import bookingService from '../../services/bookingService';
import './DaySlots.css';

// ✅ isExceptionallyClosed vient du parent (Booking.js) — pas de hook ici
const DaySlots = ({
  salonId,
  selectedDate,
  onSelectTime,
  selectedTime,
  isExceptionallyClosed = () => false,
  getClosureMessage     = () => null
}) => {
  const [slots,   setSlots]   = useState([]);
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    if (!selectedDate || !salonId) return;
    if (isExceptionallyClosed(selectedDate)) return; // ✅ Pas d'appel API
    loadDaySlots();
  }, [selectedDate, salonId]);

  const loadDaySlots = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await bookingService.getAvailableSlots(salonId, selectedDate);
      if (response.success) {
        setSlots(response.slots || []);
      } else {
        setError(response.message || 'Erreur lors du chargement des créneaux');
      }
    } catch {
      setError('Impossible de charger les créneaux disponibles');
    } finally {
      setLoading(false);
    }
  };

  const formatSelectedDate = () => {
    if (!selectedDate) return '';
    const date   = new Date(selectedDate + 'T00:00:00');
    const days   = ['Dimanche','Lundi','Mardi','Mercredi','Jeudi','Vendredi','Samedi'];
    const months = ['janvier','février','mars','avril','mai','juin','juillet','août','septembre','octobre','novembre','décembre'];
    return `${days[date.getDay()]} ${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
  };

  const groupSlotsByPeriod = () => {
    const morning = [], afternoon = [];
    slots.forEach(slot =>
      parseInt(slot.time.split(':')[0]) < 12
        ? morning.push(slot)
        : afternoon.push(slot)
    );
    return { morning, afternoon };
  };

  if (!selectedDate) {
    return (
      <div className="day-slots-placeholder">
        <p className="day-slots-message">📅 Sélectionnez une date pour voir les créneaux disponibles</p>
      </div>
    );
  }

  // ✅ Fermeture exceptionnelle
  if (isExceptionallyClosed(selectedDate)) {
    return (
      <div className="day-slots-exceptional-closure">
        <div className="closure-icon">🔒</div>
        <h4 className="closure-title">Fermeture exceptionnelle</h4>
        <p className="closure-subtitle">Le salon n'est pas disponible le {formatSelectedDate()}.</p>
        <p className="closure-hint">Veuillez choisir une autre date.</p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="day-slots-loading">
        <div className="spinner" />
        <p>Chargement des créneaux...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="day-slots-error">
        <p>❌ {error}</p>
        <button className="btn-retry" onClick={loadDaySlots}>Réessayer</button>
      </div>
    );
  }

  if (slots.length === 0) {
    return (
      <div className="day-slots-empty">
        <p>😔 Aucun créneau disponible pour le {formatSelectedDate()}</p>
        <p className="day-slots-hint">Le salon est fermé ou tous les créneaux sont complets</p>
      </div>
    );
  }

  const { morning, afternoon } = groupSlotsByPeriod();

  const renderSlots = (list) => (
    <div className="day-slots-grid">
      {list.map(slot => (
        <button
          key={slot.time}
          className={`day-slot-btn${!slot.available ? ' disabled' : ''}${selectedTime === slot.time ? ' selected' : ''}`}
          onClick={() => onSelectTime(slot.time)}
          disabled={!slot.available}
        >
          <span className="day-slot-time">{slot.time}</span>
        </button>
      ))}
    </div>
  );

  return (
    <div className="day-slots-container">
      <h4 className="day-slots-date">📅 {formatSelectedDate()}</h4>
      {morning.length > 0 && (
        <div className="day-slots-period">
          <h5 className="day-slots-period-title">🌅 Matin</h5>
          {renderSlots(morning)}
        </div>
      )}
      {afternoon.length > 0 && (
        <div className="day-slots-period">
          <h5 className="day-slots-period-title">☀️ Après-midi</h5>
          {renderSlots(afternoon)}
        </div>
      )}
    </div>
  );
};

export default DaySlots;